import { useHistory } from 'react-router-dom';
import { getUserProfile } from '../../helpers/userProfile';
import LogoCelciusColor from '../../assets/img/logos/LogoCelciusColor.svg';
import {
  StyledLink,
  Background,
  LogoContainer,
  InfoHeader,
  CreditosMobile,
} from './styles';
import { useContext, useEffect, useState } from 'react';
import { SpringerLogo } from '~/icons';
import { getUserClientId } from '~/helpers/getClientsHelper';
import { MenuLink } from '../Menu';
import overviewIcon from '../../assets/img/sidebar/NovoVisaoGeral.svg';
import homeIcon from '../../assets/img/sidebar/Home.svg';
import helpIcon from '../../assets/img/sidebar/help-circle.svg';
import navigationIcon from '../../assets/img/sidebar/Navigation.svg';
import userIcon from '../../assets/img/sidebar/NovoUsuarios.svg';
import alertsIcon from '../../assets/img/sidebar/Alertas.svg';
import analysisIcon from '../../assets/img/sidebar/NovoAnalise.svg';
import clientPanelIcon from '../../assets/img/sidebar/NovoClientPanel.svg';
import logoDielIcon from '../../assets/img/logos/LogoDielPowered.svg';
import supportIcon from '../../assets/img/sidebar/Support.svg';
import SelectPlataformContext from '../../contexts/selectPlataform';

import { t } from 'i18next';
import {
  MenuItem, MenuItemImg, MenuItemName,
} from '../Menu/styles';

export const MenuMobile = ({ setIsModalNavItemsOpen }): JSX.Element => {
  const history = useHistory();
  const [profile] = useState(getUserProfile);
  const ActionableWrapper = ({ children }) => <div style={{ width: '100%' }} onClick={() => setIsModalNavItemsOpen(false)}>{children}</div>;
  const [clientIds, setClientIds] = useState<number[] | null>(null);
  const menuLinkIsActive = (link: string) => history.location.pathname.includes(link);
  const { selectPlataform } = useContext(SelectPlataformContext);
  const selectRemoteControl = selectPlataform === '/controle-inteligente';
  const isAllowClientOverview = !profile.permissions.isInstaller && !selectRemoteControl;
  const principalItemsMenu = [
    {
      to: '/nova-visao-geral',
      name: t('inicio'),
      altImage: 'new-overview-icon',
      image: homeIcon,
      visible: isAllowClientOverview,
      isActive: menuLinkIsActive('/nova-visao-geral'),
    },
    {
      to: '/analise/unidades',
      name: t('analise'),
      altImage: t('analise'),
      image: analysisIcon,
      visible: !selectRemoteControl,
      isActive: menuLinkIsActive('/analise') || menuLinkIsActive('/integracoes'),
    },
    {
      to: '/alertas/feed',
      name: t('alertas'),
      altImage: t('alertas'),
      image: alertsIcon,
      visible: !selectRemoteControl,
      isActive: menuLinkIsActive('/alertas'),
    },
    {
      to: '/usuarios',
      name: t('usuarios'),
      altImage: t('usuarios'),
      image: userIcon,
      visible: !profile.permissions.isInstaller && !selectRemoteControl,
      isActive: menuLinkIsActive('/usuarios'),
    },
    {
      to: '/controle-inteligente',
      name: t('paginaInicial'),
      altImage: t('controleInteligente'),
      image: homeIcon,
      visible: selectRemoteControl && !profile.permissions.isAdminSistema,
      isActive: menuLinkIsActive('/controle-inteligente'),
    },
    {
      to: '/faq-controle-remoto',
      name: t('ajuda'),
      altImage: t('ajuda'),
      image: helpIcon,
      visible: selectRemoteControl,
      isActive: menuLinkIsActive('/faq-controle-remoto'),
      externalLink: false,
    },
  ];

  useEffect(() => {
    getUserClientId({ profile, setClientIds });
  }, []);

  return (
    <Background>
      <ActionableWrapper>
        <LogoContainer>
          <div style={{ width: '18px' }} />
          {/* 157 - Atacadão
          158 - Carrier */}
          <StyledLink style={{ paddingRight: '12px' }} to="/visao-geral">
            {
              (clientIds && clientIds?.filter((item) => (item !== 157 && item !== 158)).length !== 0 || profile.permissions.isAdminSistema) && <img src={LogoCelciusColor} alt="logoCelcius " />
            }
            {
              (clientIds && clientIds?.filter((item) => (item !== 157 && item !== 158)).length === 0 && !profile.permissions.isAdminSistema) && <SpringerLogo color="black" />
            }
          </StyledLink>
          <div style={{ width: '20px' }} />
        </LogoContainer>
      </ActionableWrapper>
      <InfoHeader>
        { t('PRINCIPAL') }
      </InfoHeader>
      {principalItemsMenu.map((item) => item.visible && (
        item.externalLink ? (
          <a
            key={item.to}
            href={item.to}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', width: '100%' }}
            onClick={() => setIsModalNavItemsOpen(false)}
          >
            <MenuItem isOpen isActive={false} isMobile>
              <div>
                <MenuItemImg src={item.image} alt={item.altImage} />
                <MenuItemName>{item.name}</MenuItemName>
              </div>
            </MenuItem>
          </a>
        ) : (
          <MenuLink
            key={item.to}
            menuToogle
            linkTo={item.to}
            image={item.image}
            altImage={item.altImage}
            name={item.name}
            isActive={item.isActive}
            visible={item.visible}
            click={() => setIsModalNavItemsOpen(false)}
            isMobile
          />
        )
      ))}

      {!profile.permissions.isPersonaII && (!!profile.manageAllClients || ((!profile.manageAllClients) && (profile.manageSomeClient) && !profile.permissions.isInstaller)) && (
      <>
        <InfoHeader>
          {t('CONTA')}
        </InfoHeader>

        <MenuLink
          menuToogle
          linkTo="/painel/clientes/listagem"
          image={clientPanelIcon}
          altImage={t('painel')}
          name={t('painel')}
          isActive={menuLinkIsActive('/painel')}
          visible={!!profile.manageAllClients}
          click={() => {
            setIsModalNavItemsOpen(false);
          }}
          isMobile
        />
        <MenuLink
          menuToogle
          isMobile
          image={clientPanelIcon}
          isActive={menuLinkIsActive('/painel')}
          name={t('painel')}
          linkTo="/painel/client-painel"
          altImage={t('painel')}
          visible={!!(!profile.manageAllClients && profile.manageSomeClient && !profile.permissions.isInstaller)}
          click={() => {
            setIsModalNavItemsOpen(false);
          }}
        />
      </>
      )}
      <CreditosMobile>
        Powered by
        {' '}
        <img src={logoDielIcon} alt="diel logo" />
      </CreditosMobile>
    </Background>
  );
};
